const $ = window.jQuery;
const $window = window.$window || $(window);
import TabAccordion from 'storm-tab-accordion';


const tabsVertical = {
    init() {
        var $module = $(".js-tab-accordion");
        if (!$module.length) return;

        $module.each((index, element) => {
            this.each(element);
        });
    },

    each(element) {
        TabAccordion.init('.js-tab-accordion');
    },
};

export default tabsVertical;
